import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { BE_API_AUTH_URL } from '../constants/app.constants';
import {
  ActivePropertyImportJobResponse,
  CreatePropertyImportJobResponse,
  PropertyImportSource,
  PropertyImportJobResultResponse,
  PropertyImportJobStatusResponse,
} from '../models/property-import.models';

@Injectable({
  providedIn: 'root',
})
export class PropertyImportService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  createImportJob(
    file: File,
    source: PropertyImportSource,
    clientRequestId?: string
  ): Observable<CreatePropertyImportJobResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('source', source);
    if (clientRequestId) {
      formData.append('clientRequestId', clientRequestId);
    }

    return this.http
      .post<CreatePropertyImportJobResponse>(
        `${BE_API_AUTH_URL}/property-import-jobs`,
        formData,
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getImportJob(jobId: string): Observable<PropertyImportJobStatusResponse> {
    return this.http
      .get<PropertyImportJobStatusResponse>(
        `${BE_API_AUTH_URL}/property-import-jobs/${encodeURIComponent(jobId)}`,
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getImportJobResult(jobId: string): Observable<PropertyImportJobResultResponse> {
    return this.http
      .get<PropertyImportJobResultResponse>(
        `${BE_API_AUTH_URL}/property-import-jobs/${encodeURIComponent(jobId)}/result`,
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getActiveImportJob(): Observable<ActivePropertyImportJobResponse> {
    return this.http
      .get<ActivePropertyImportJobResponse>(
        `${BE_API_AUTH_URL}/property-import-jobs/active`,
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  downloadImportJobErrorsWorkbook(jobId: string, lang: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get(
        `${BE_API_AUTH_URL}/property-import-jobs/${encodeURIComponent(jobId)}/errors.xlsx?lang=${encodeURIComponent(lang)}`,
        {
          headers: this.authService.createAuthorizationHeader(),
          observe: 'response',
          responseType: 'blob',
        }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
